export default "__VITE_ASSET__CDFIazxF__"